// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2sPDm","list":"BalanceDue_list__39mNg","listRow":"BalanceDue_listRow__fiFov","total":"BalanceDue_total__1IN5l"};